import { MutationTree } from 'vuex';
import { NewsletterState } from './types';
import {
    GroupRecipientResource,
    GroupResource,
    ListRecipientResource,
    ListResource,
} from '@/api/requests/newsletter/mailup/types';

export const mutations: MutationTree<NewsletterState> = {
    /**
     * Add active groups recipients.
     *
     * @param state
     * @param recipients
     */
    addActiveGroupsRecipients(state, recipients: GroupRecipientResource[]) {
        state.activeGroupsRecipients = state.activeGroupsRecipients.concat(recipients);
    },

    /**
     * Add a list to the state.
     *
     * @param state
     * @param list
     */
    addList(state, list: ListResource) {
        state.lists.push(list);
    },

    /**
     * Remove a list from the state.
     *
     * @param state
     * @param listId
     */
    removeList(state, listId) {
        state.lists = state.lists.filter((list) => list.idList !== listId);
    },

    /**
     * Remove a group from the state.
     *
     * @param state
     * @param groupId
     */
    removeGroup(state, groupId) {
        state.activeListGroups = state.activeListGroups.filter((group) => group.idGroup !== groupId);
    },

    /**
     * Add active groups recipients.
     *
     * @param state
     * @param groupId
     */
    removeActiveGroupsRecipientsByGroupId(state, groupId: number) {
        state.activeGroupsRecipients = state.activeGroupsRecipients.filter((recipient: GroupRecipientResource) => {
            return recipient.idGroup !== groupId;
        });
    },

    /**
     * Reset active list.
     *
     * @param state
     */
    resetActiveList(state) {
        state.activeList = null;
    },

    /**
     * Reset active list groups.
     *
     * @param state
     */
    resetActiveListGroups(state) {
        state.activeListGroups = [];
    },

    /**
     * Reset active list recipients.
     *
     * @param state
     */
    resetActiveListRecipients(state) {
        state.activeListRecipients = [];
    },

    /**
     * Reset active groups recipients.
     *
     * @param state
     */
    resetActiveGroupsRecipients(state) {
        state.activeGroupsRecipients = [];
    },

    /**
     * Reset lists.
     *
     * @param state
     */
    resetLists(state) {
        state.lists = [];
    },

    /**
     * Set active list.
     *
     * @param state
     * @param list
     */
    setActiveList(state, list: ListResource) {
        state.activeList = list;
    },

    /**
     * Set active list groups.
     *
     * @param state
     * @param groups
     */
    setActiveListGroups(state, groups: GroupResource[]) {
        state.activeListGroups = groups;
    },

    /**
     * Set active list recipients.
     *
     * @param state
     * @param recipients
     */
    setActiveListRecipients(state, recipients: ListRecipientResource[]) {
        state.activeListRecipients = recipients;
    },

    /**
     * Set active list recipients.
     *
     * @param state
     * @param recipients
     */
    setActiveGroupsRecipients(state, recipients: GroupRecipientResource[]) {
        state.activeGroupsRecipients = recipients;
    },

    /**
     * Set mailup lists.
     *
     * @param state
     * @param lists
     */
    setLists(state, lists) {
        state.lists = lists;
    },

    /**
     * Set mailup logged.
     *
     * @param state
     * @param logged
     */
    setMailupLogged(state, logged: boolean = true) {
        state.mailupLogged = logged;
    },

    /**
     * Update a group.
     *
     * @param state
     * @param group
     */
    updateGroup(state, group) {
        const index = state.activeListGroups.findIndex((item) => item.idGroup === group.idGroup);
        state.activeListGroups.splice(index, 1, group);
    },

    /**
     * Update a list.
     *
     * @param state
     * @param list
     */
    updateList(state, list) {
        const index = state.lists.findIndex((item) => item.idList === list.idList);
        state.lists.splice(index, 1, list);
    },
};
